import {
  SR_API_ACTION_GET_UNAVAILABLE_TOUR_DATES,
} from 'api/actionTypes';

export default async function getUnavailableTourDates({ state, apiClient }) {
  const marketId = state.get(['markets', 'currentUserMarket', 'id']);

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_UNAVAILABLE_TOUR_DATES,
    state: state,
    payload: { marketId },
    onSuccess({ unavailableTourDates }) {
      state.set(['unavailableTourDates'], unavailableTourDates);
    },
  });
}
